

import store from "../store/store";
import { IUserType } from "../types";
import { firebase } from "../config/firebase.client";
import { onValue, update, off, query, orderByChild, equalTo, get } from "firebase/database";
import { uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { onAuthStateChanged, signInWithCredential, signInWithPopup, signOut, sendPasswordResetEmail, signInWithEmailAndPassword, sendEmailVerification, OAuthCredentialOptions } from "firebase/auth";
import { FETCH_USER, FETCH_USER_SUCCESS, FETCH_USER_FAILED, USER_SIGN_IN, USER_SIGN_IN_FAILED, USER_SIGN_OUT, CLEAR_LOGIN_ERROR, REQUEST_OTP_SUCCESS, UPDATE_USER_WALLET_HISTORY, SEND_RESET_EMAIL, SEND_RESET_EMAIL_FAILED } from "../store/types";

export const fetchIsEmailVerified = () => (dispatch: any) => {
  const { auth } = firebase;

  return auth.currentUser
}

export const uploadImageFirebase = async (uid: string, image: any) => {
  const { uploadImageTaxi } = firebase;

  await uploadBytesResumable(uploadImageTaxi(uid), image);
  let uploadimage = await getDownloadURL(uploadImageTaxi(uid));

  return uploadimage;
};

export const fetchUser = () => (dispatch: any) => {
  const { auth, singleUserRef } = firebase;

  dispatch({
    type: FETCH_USER,
    payload: null,
  });

  onAuthStateChanged(auth, (user) => {
    if (user) {
      onValue(singleUserRef(user.uid), async (snapshot) => {
        if (snapshot.val()) {
          let profile = snapshot.val();
          profile.uid = user.uid;
          dispatch({
            type: FETCH_USER_SUCCESS,
            payload: profile,
          });
        }
      });
    } else {
      dispatch({
        type: FETCH_USER_FAILED,
        payload: {
          code: store.getState().languagedata.defaultLanguage.auth_error,
          message: store.getState().languagedata.defaultLanguage.not_logged_in,
        },
      });
    }
  });
};

export const validateReferer = async (referralId: IUserType['referralId']) => {
  const { config } = firebase;
  const response = await fetch(


    `https://us-central1-${config.projectId}.cloudfunctions.net/validate_referrer`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        referralId: referralId,
      }),
    }
  );
  const json = await response.json();
  return json;
};

export const checkUserExists = async (data: IUserType) => {
  const { config } = firebase;

  let url = `https://us-central1-${config.projectId}.cloudfunctions.net/check_user_exists`;



  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: data.email,
      mobile: data.mobile,
    }),

  });
  const json = await response.json();
  return json;
};

export const mainSignUp = async (regData: IUserType) => {
  const { config } = firebase;
  let url = `https://us-central1-${config.projectId}.cloudfunctions.net/user_signup`;


  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ regData: regData }),
  });
  const res = await response.json();

  return res;
};

export const mainSignUpFleetAdmin = async (regData: IUserType) => {
  const { config } = firebase;

  let url = `https://us-central1-${config.projectId}.cloudfunctions.net/user_signup_fletAdmin`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ regData: { ...regData, lastName: '' } }),
  });

  const responseData = await response.json();

  return responseData;
};

export const mobileSignIn = (verficationId: string, code: string) => (dispatch: any) => {
  const { auth, mobileAuthCredential } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null,
  });
  signInWithCredential(auth, mobileAuthCredential(verficationId, code))
    .then((user) => {

    })
    .catch((error) => {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error,
      });
    });
};

export const googleLogin = (idToken: string, accessToken: string) => (dispatch: any) => {
  const { auth, googleCredential } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null,
  });

  const credential: any = googleCredential(idToken, accessToken);
  signInWithCredential(auth, credential)
    .then((user) => {

    })
    .catch((error) => {
      console.error(error);
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error,
      });
    });
};

export const appleSignIn = (credentialData: OAuthCredentialOptions) => (dispatch: any) => {
  const { auth, appleProvider } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null,
  });
  if (credentialData) {
    const credential: any = appleProvider.credential(credentialData);
    signInWithCredential(auth, credential)
      .then((user) => { })
      .catch((error) => {
        dispatch({
          type: USER_SIGN_IN_FAILED,
          payload: error,
        });
      });
  } else {
    signInWithPopup(auth, appleProvider)
      .then(function (result: any) {
        signInWithCredential(auth, result.credential)
          .then((user) => { })
          .catch((error) => {
            dispatch({
              type: USER_SIGN_IN_FAILED,
              payload: error,
            });
          });
      })
      .catch(function (error) {
        dispatch({
          type: USER_SIGN_IN_FAILED,
          payload: error,
        });
      });
  }
};

export const signOff = () => (dispatch: any) => {
  const { auth, singleUserRef, walletHistoryRef, userNotificationsRef } = firebase;

  const uid = auth?.currentUser?.uid;

  if (!uid) return;

  off(singleUserRef(uid));
  off(walletHistoryRef(uid));
  off(userNotificationsRef(uid));

  onValue(
    singleUserRef(uid),
    (snapshot) => {
      if (snapshot.val()) {
        const profile = snapshot.val();
        if (profile && profile.usertype === "driver") {
          update(singleUserRef(uid), { driverActiveStatus: false });
        }
        setTimeout(() => {
          signOut(auth)
            .then(() => {
              dispatch({
                type: USER_SIGN_OUT,
                payload: null,
              });
            })
            .catch((error) => { });
        }, 1000);
      }
    },
    { onlyOnce: true }
  );
};

export const updateProfile = (updateData: any) => async (dispatch: any) => {
  const {
    auth,
    usersRef,
    singleUserRef,
    driverDocsRef,
    driverDocsRefBack,
    verifyIdImageRef,
    verifyIdImageSelfieRef,
  } = firebase;

  const uid = auth?.currentUser?.uid;

  if (!uid) return;


  if (updateData.licenseImage) {
    await uploadBytesResumable(driverDocsRef(uid), updateData.licenseImage);
    updateData.licenseImage = await getDownloadURL(driverDocsRef(uid));
  }

  if (updateData.licenseImageBack) {
    await uploadBytesResumable(
      driverDocsRefBack(uid),
      updateData.licenseImageBack
    );
    updateData.licenseImageBack = await getDownloadURL(driverDocsRefBack(uid));
  }

  if (updateData.verifyIdImage) {
    await uploadBytesResumable(verifyIdImageRef(uid), updateData.verifyIdImage);
    updateData.verifyIdImage = await getDownloadURL(verifyIdImageRef(uid));
  }

  if (updateData.verifyIdImageSelfie) {
    await uploadBytesResumable(
      verifyIdImageSelfieRef(uid),
      updateData.verifyIdImageSelfie
    );
    updateData.verifyIdImageSelfie = await getDownloadURL(
      verifyIdImageSelfieRef(uid)
    );
  }

  await update(singleUserRef(uid), updateData);
};

export const checkVerifyIdExists = async (updateData: IUserType) => {
  const { usersRef } = firebase;

  if (updateData.verifyId && updateData.verifyId.trim() !== '') {

    const verifyIdQuery = query(usersRef, orderByChild('verifyId'), equalTo(updateData.verifyId));
    const snapshot = await get(verifyIdQuery);

    let verifyIdExists = false;

    if (snapshot.exists()) {
      snapshot.forEach((childSnapshot) => {
        const userData = childSnapshot.val() as IUserType;

        if (childSnapshot.key !== updateData.uid && userData.usertype === updateData.usertype) {
          verifyIdExists = true;
          return true;
        }
        return false;
      });
    }

    if (verifyIdExists) {
      return true;
    }
  }

  return false;
};

export const updateProfileImage = async (imageBlob: any) => {
  const { auth, singleUserRef, profileImageRef } = firebase;

  const uid = auth?.currentUser?.uid;

  if (!uid) return;

  try {
    if (!imageBlob) {
      try {
        await deleteObject(profileImageRef(uid));
      } catch (error) {
      }

      await update(singleUserRef(uid), { profile_image: null });
      return;
    }

    await uploadBytesResumable(profileImageRef(uid), imageBlob);

    if (typeof imageBlob.close === 'function') {
      imageBlob.close();
    }

    const url = await getDownloadURL(profileImageRef(uid));
    await update(singleUserRef(uid), { profile_image: url });

  } catch (error) {
    console.error("Error updating profile image:", error);
    throw error;
  }
};

export const setUserAccountStatus = async (uid: string, disabled: boolean, reason: string) => {

  const result = await firebase.callFunction('setUserAccountStatus', {
    uid,
    reason,
    disabled,
  });

  return result;
};

export const updatePushToken = (token: string, platform: any) => {
  const { auth, singleUserRef } = firebase;

  const uid = auth?.currentUser?.uid;

  if (!uid) return;
  update(singleUserRef(uid), {
    pushToken: token,
    userPlatform: platform,
  });
};

export const clearLoginError = () => (dispatch: any) => {
  dispatch({
    type: CLEAR_LOGIN_ERROR,
    payload: null,
  });
};

export const fetchWalletHistory = () => (dispatch: any) => {
  const { auth, walletHistoryRef } = firebase;

  const uid = auth?.currentUser?.uid;

  if (!uid) return;

  onValue(walletHistoryRef(uid), (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const arr = Object.keys(data).map((i) => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: arr.reverse(),
      });
    }
  });
};

export const sendResetMail = (email: string, appId?: string) => async (dispatch: any) => {
  const { authRef } = firebase;

  dispatch({
    type: SEND_RESET_EMAIL,
    payload: email,
  });
  sendPasswordResetEmail(authRef(), email)
    .then(function () {

    })
    .catch(function (error) {
      dispatch({
        type: SEND_RESET_EMAIL_FAILED,
        payload: {
          code: store.getState().languagedata.defaultLanguage.auth_error,
          message: store.getState().languagedata.defaultLanguage.not_registred,
        },
      });
    });
};

export const verifyEmailPassword = (email: IUserType['email'], password: IUserType['email'], appId?: string) => async (dispatch: any) => {
  const { authRef } = firebase;

  signInWithEmailAndPassword(authRef(), email, password)
    .then((user) => {
      if (!user?.user.emailVerified) {
        sendEmailVerification(user.user);
      }
    })
    .catch((error) => {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error,
      });
    });
};
